import script from "./AspectoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AspectoView.vue?vue&type=script&setup=true&lang=js"

import "./AspectoView.vue?vue&type=style&index=0&id=b0f15ab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0f15ab4"]])

export default __exports__